export interface Contatos {
    tipo: string;
    valor: string;
}

export  const Contatos: Contatos[] = [
    {tipo:'email',valor: "isaactiagowandermure@gmail.com"},
    {tipo:'github',valor: "https://github.com/isaactiago"},
    {tipo:'linkedin',valor: "www.linkedin.com/in/isaac-tiago-wandermurem"},
    {tipo:'instagram',valor: "https://www.instagram.com/isaactwzim/"},
    {tipo:'telefone',valor: "https://wa.me/27996908012"},
]